import { Controller } from "stimulus";

export default class extends Controller {
  toggle(event) {
    const toggle = event.currentTarget;
    const group = toggle.closest(".unit-card-group");
    if (!group) return;

    const list = group.querySelector(".unit-lessons-list");
    if (!list) return;

    const isOpen = list.classList.toggle("is-open");
    toggle.classList.toggle("is-open", isOpen);
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }
}
